// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

// 用户管理
import User from '@/views/user/User';

// 用户管理
import User2 from '@/views/user/User2';
import SchoolMap from '@/views/user/SchoolMap';
// 管理员管理
import Admin from '@/views/system/Admin';

// 商品管理
import Goods from '@/views/goods/Goods';
// 商品分类
import Classify from '@/views/goods/Classify';
// 交易订单
import Order from '@/views/pay/Order';

// 财务明细
import Finance from '@/views/finance/Finance';
// 提现管理
import Withdraw from '@/views/finance/Withdraw';
// 押金管理
import Deposit from '@/views/finance/Deposit';

// 轮播图管理
import Carousel from '@/views/terrace/Carousel';
import TvUpdateConfig from '@/views/terrace/TvUpdateConfig';

// 协议管理
import Agreement from '@/views/terrace/Agreement';

// 资讯分类管理
import NewsClassify from '@/views/terrace/NewsClassify';


import Valuation from '@/views/terrace/Valuation';


//合作课程
import CourseOne from '@/views/cooperation/CourseOne';
import CourseTwo from '@/views/cooperation/CourseTwo';
import CourseThree from '@/views/cooperation/CourseThree';
import CourseFour from '@/views/cooperation/CourseFour';
import CourseList from '@/views/cooperation/CourseList';


//合作课程
import CourseOneClassify from '@/views/cooperationClassify/CourseOneClassify';
import CourseTwoClassify from '@/views/cooperationClassify/CourseTwoClassify';
import CourseThreeClassify from '@/views/cooperationClassify/CourseThreeClassify';
import CourseFourClassify from '@/views/cooperationClassify/CourseFourClassify';
import CourseListClassify from '@/views/cooperationClassify/CourseListClassify';


//视频课程
import VideoCourse from '@/views/videoCourse/VideoCourse';


import Activity from '@/views/activity/Activity';
import LiveCourse from '@/views/liveCourse/LiveCourse';
import Campus from '@/views/campus/Campus';


import Teacher from '@/views/teacher/Teacher';

import Introduce from '@/views/teacher/Introduce';






// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        redirect: '/User/SchoolMap',
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/User/User',
            name: '用户管理',
            component: User,
            meta: {
                requireAuth: true
            }
        },{
            path: '/User/User2',
            name: '用户管理2',
            component: User2,
            meta: {
                requireAuth: true
            }
        },{
            path: '/User/SchoolMap',
            name: '学校地图看板',
            component: SchoolMap,
            meta: {
                requireAuth: true
            }
        },{
            path: '/goods/Goods',
            name: '商品管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
        },{
            path: '/goods/Classify',
            name: '商品分类',
            component: Classify,
            meta: {
                requireAuth: true
            }
        },{
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        },{
            path: '/finance/Finance',
            name: '财务明细',
            component: Finance,
            meta: {
                requireAuth: true
            }
        },{
            path: '/finance/Withdraw',
            name: '提现管理',
            component: Withdraw,
            meta: {
                requireAuth: true
            }
        },{
            path: '/finance/Deposit',
            name: '押金管理',
            component: Deposit,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/Carousel',
            name: '轮播图管理',
            component: Carousel,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/CategoryHeroCarousel',
            name: '电脑网页分类背景轮播管理',
            component: Carousel,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/WebCategoryHeroCarousel',
            name: '电脑网页分类背景轮播管理',
            component: Carousel,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/TvCategoryHeroCarousel',
            name: '电视机分类背景轮播管理',
            component: Carousel,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/TvUpdateConfig',
            name: '电视更新配置管理',
            component: TvUpdateConfig,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/Agreement',
            name: '协议管理',
            component: Agreement,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/NewsClassify',
            name: '分类管理',
            component: NewsClassify,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/terrace/Valuation',
            name: '基础设置',
            component: Valuation,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/Admin',
            name: '管理员管理',
            component: Admin,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperation/CourseOne',
            name: '合作课程一级内容',
            component: CourseOne,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperation/CourseTwo',
            name: '合作课程二级内容',
            component: CourseTwo,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperation/CourseThree',
            name: '合作课程三级内容',
            component: CourseThree,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperation/CourseFour',
            name: '合作课程四级内容',
            component: CourseFour,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperation/CourseList',
            name: '合作课程内容',
            component: CourseList,
            meta: {
                requireAuth: true
            }
        },{
            path: '/videoCourse/VideoCourse',
            name: '视频课程',
            component: VideoCourse,
            meta: {
                requireAuth: true
            }
        },{
            path: '/liveCourse/LiveCourse',
            name: '直播课程',
            component: LiveCourse,
            meta: {
                requireAuth: true
            }
        },{
            path: '/activity/Activity',
            name: '活动管理',
            component: Activity,
            meta: {
                requireAuth: true
            }
        },{
            path: '/campus/Campus',
            name: '校区管理',
            component: Campus,
            meta: {
                requireAuth: true
            }
        },{
            path: '/teacher/Teacher',
            name: '老师管理',
            component: Teacher,
            meta: {
                requireAuth: true
            }
        },{
            path: '/teacher/Introduce',
            name: '课程介绍管理',
            component: Introduce,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperationClassify/CourseOneClassify',
            name: '合作课程一级内容',
            component: CourseOneClassify,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperationClassify/CourseTwoClassify',
            name: '合作课程二级内容',
            component: CourseTwoClassify,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperationClassify/CourseThreeClassify',
            name: '合作课程三级内容',
            component: CourseThreeClassify,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperationClassify/CourseFourClassify',
            name: '合作课程四级内容',
            component: CourseFourClassify,
            meta: {
                requireAuth: true
            }
        },{
            path: '/cooperationClassify/CourseListClassify',
            name: '合作课程内容',
            component: CourseListClassify,
            meta: {
                requireAuth: true
            }
        }]
    }]
})




// WEBPACK FOOTER //
// ./src/router/index.js